import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.widget.as.status');
import { Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-afterservice-widget-as-status',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.widget.as.status/view.scss */
/* src/app/portal.afterservice.widget.as.status/view.scss: no such file or directory */`],
})
export class PortalAfterserviceWidgetAsStatusComponent implements OnInit {
    @Input() search!: { text: string };
    @Input() loading: boolean = false;
    @Output() submit = new EventEmitter<void>();

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }
}

export default PortalAfterserviceWidgetAsStatusComponent;